import BasicLayout from '@/layout/BasicLayout.vue'

const andonRouter = {
  path: '/andon',
  component: BasicLayout,
  children: [
    {
      path: '/andon/callAccept',
      component: () => import('../../views/andon/callAccept/index.vue')
    },
    {
      path: '/andon/confirmRecord',
      component: () => import('../../views/andon/confirmRecord/index.vue')
    },
    {
      path: '/andon/frequencyStatistics',
      component: () => import('@/views/andon/frequencyStatistics/index')
    }
  ]
}

export default andonRouter
